import moment from 'moment';
import { FeatureUpdate } from 'shared/types/featureUpdate';

import baixarDanfseXMLPNG from './images/baixarDanfseXml.png';
import cardBoletimPNG from './images/cardBoletim.png';
import historicoPedidosPNG from './images/historicoPedidos.png';

const updates: FeatureUpdate[] = [
  {
    date: moment('2024-05-8'),
    title: 'Novo delivery',
    content:
      'A aba de delivery foi atualizada, com informações sobre o endereço e uma lista dos bairros/raios de entrega. O histórico de pedidos também foi adicionado, nele é possível visualizar os últimos pedidos daquele App, ver os detalhes do pagamento e atualizar o status do pedido.',
    highlight: [
      'aba de delivery',
      'informações sobre o endereço',
      'lista dos bairros/raios',
      'histórico de pedidos',
      'atualizar o status do pedido.',
    ],
    type: 'feature',
    version: '1.3.0',
    imageSrc: historicoPedidosPNG,
  },
  {
    date: moment('2026-03-17'),
    title: 'CEP inexistente',
    content:
      'Agora ao criar um novo cliente ou editar um existente, se o CEP for inexistente, será exibido um alerta com links para encontrar o CEP correto.',
    highlight: ['CEP inexistente'],
    type: 'feature',
    version: '2025.7.62',
  },
  {
    date: moment('2026-04-07'),
    title: 'Baixar DANFSE e XML',
    content:
      'Agora é possível baixar a DANFSE e o XML da NFS-e dentro do modal de detalhes da cobrança.',
    highlight: ['Baixar DANFSE/XML'],
    type: 'feature',
    version: '2025.7.65',
    imageSrc: baixarDanfseXMLPNG,
  },
  {
    date: moment('2026-04-09'),
    title: 'Boletim',
    content: 'Agora é possível manipular o boletim de clientes dentro do App.',
    highlight: ['Boletim'],
    type: 'feature',
    version: '2025.7.67',
    imageSrc: cardBoletimPNG,
  },
];

export default updates;
